import { Component, input } from '@angular/core';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-menu2-subitem',
    templateUrl: './menu2-subitem.component.html',
    styleUrls: ['./menu2-subitem.component.scss'],
    standalone: false
})
export class Menu2SubitemComponent {
    column = input<any>(null);
    constructor(
        protected mediaService: MediaService
    ) {
    }

}
